import { useEffect } from "react";
import { AudioProvider } from "./context/audioContext";
import Game from "./pages/Game";
import useCounterStore from "./store/store";
import "./styles/global.css";
import { getLocalItem, setLocalItem } from "./utils/helpers";

const App = () => {
  const { setWalletAmt } = useCounterStore((state) => state);

  const freeCoins: number = 10000;

  useEffect(() => {
    const checkLocal = getLocalItem("depositAmt");

    if (checkLocal) {
      setWalletAmt(Number(checkLocal));
    } else {
      setLocalItem("depositAmt", freeCoins);
      setWalletAmt(freeCoins);
    }
  }, []);

  return (
    <AudioProvider>
      <div className="app">
        <Game />
      </div>
    </AudioProvider>
  );
};

export default App;
